import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["theme"];
import "core-js/modules/es.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useContext } from 'react';
var ThemeContext = /*#__PURE__*/createContext('light');
var ThemeConsumer = ThemeContext.Consumer;

var getInverseTheme = function getInverseTheme(theme) {
  return theme === 'light' ? 'dark' : 'light';
};

var useTheme = function useTheme(overwriteValue) {
  var themeFromContext = useContext(ThemeContext);
  return overwriteValue || themeFromContext;
};
/**
 * @deprecated use `useTheme` hook instead
 * */


var withTheme = function withTheme(wrappedComponent) {
  var WrappedComponent = wrappedComponent;
  var ComponentWithTheme = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var theme = _ref.theme,
        restProps = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement(ThemeConsumer, null, function (themeFromContext) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _objectSpread({
        ref: ref,
        theme: theme || themeFromContext
      }, restProps));
    });
  });
  ComponentWithTheme.displayName = "WithTheme(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return ComponentWithTheme;
};

export { ThemeConsumer, ThemeContext, getInverseTheme, useTheme, withTheme };
